import API from '../../../API/api';
import {
    cartMixedStocksComputeStarted,
    cartMixedStocksComputeSuccess,
    cartMixedStocksComputeFailed
} from '../../actions/http_request/product_mixed_stocks_compute_actions';
import CART_ITEM_STOCK_TYPES from '../../constants/cart_item_stock_types';
import ADDRESS_TYPES from '../../constants/address_types';

/**
 * @param postcode
 * @param sku
 * @param quantity
 * @returns {*}
 */
function cartMixedStocksComputeRequest(postcode, sku, quantity) {
    'use strict';
    const data = {
        'items': [
            {
                productCode: sku,
                stockType: CART_ITEM_STOCK_TYPES.MIXED_STOCK,
                itemStocks: [
                    {qty: quantity}
                ],
            }
        ],
        'shippingAddress': {
            addressType: ADDRESS_TYPES.BUSINESS,
            postcode: postcode
        }
    };
    const payload = JSON.stringify(data);

    cartMixedStocksComputeStarted();
    return API.POST({
        apiPath: '/api/v2/carts/mixedstocks/compute/',
        data: payload,
        dataType: 'json',
        contentType: 'application/json; charset=utf-8'
    }).catch(() => {
        cartMixedStocksComputeFailed();
    }).done(() => {
        cartMixedStocksComputeSuccess();
    });
}

export default cartMixedStocksComputeRequest;